import { render } from "./TabAlberoAttivitaProgetto.vue?vue&type=template&id=62bd4c18&scoped=true"
import script from "./TabAlberoAttivitaProgetto.vue?vue&type=script&lang=js"
export * from "./TabAlberoAttivitaProgetto.vue?vue&type=script&lang=js"

import "./TabAlberoAttivitaProgetto.vue?vue&type=style&index=0&id=62bd4c18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62bd4c18"]])

export default __exports__